module.exports = __webpack_public_path__ + "files/22d4a86997ef38283721a301675f2314.png";